import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface NewsContentAreaStyles {
    wrapper?: InjectableCss;
    contentSection?: InjectableCss;
    headingSection?: InjectableCss;
    sectionalContent?: InjectableCss;
    leftSection?: InjectableCss;
}

export const newsContentAreaStyles: NewsContentAreaStyles = {
    wrapper: {
        css: css`
            width: 100%;
        `,
    },
    contentSection: {
        css: css`
            width: 100%;
            max-width: 1134px;
            margin: 0 auto;
            padding: 48px 50px 0;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 40px 20px 0;
                    `,
                    css`
                        padding: 48px 30px 0;
                    `,
                    css`
                        padding: 48px 40px 0;
                    `,
                ]);
            }}
        `,
    },
    headingSection: {
        css: css`
            width: 100%;
        `,
    },
    sectionalContent: {
        css: css`
            width: 100%;
            display: flex;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                ]);
            }}
        `,
    },
    leftSection: {
        css: css`
            width: fit-content;
        `,
    },
};

const styles = newsContentAreaStyles;

const NewsContentArea: React.FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper>
                <Zone contentId={id} zoneName="Banner"></Zone>
            </StyledWrapper>
            <StyledWrapper {...styles.contentSection}>
                <StyledWrapper {...styles.headingSection}>
                    <Zone contentId={id} zoneName="Content1"></Zone>
                </StyledWrapper>
                <StyledWrapper {...styles.sectionalContent}>
                    <StyledWrapper {...styles.leftSection}>
                        <Zone contentId={id} zoneName="Content2"></Zone>
                    </StyledWrapper>
                    <Zone contentId={id} zoneName="Content3"></Zone>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper>
                <Zone contentId={id} zoneName="Content4"></Zone>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    displayName: "News Content Area",
    fieldDefinitions: [],
};

const widgetModule: WidgetModule = {
    component: NewsContentArea,
    definition,
};

export default widgetModule;
